export enum TransactionTypeEnum {
  top_up = 'credit',
  hold = 'hold',
  release = 'release',
  withdraw = 'debit',
}
